module.exports = __webpack_public_path__ + "static/TlwgTypewriter-Bold-5941033d2fdc114171a433cce78113a6.woff";